import BodyLayout from './layout.vue'

BodyLayout.install = function (Vue) {
  Vue.component(BodyLayout.name, BodyLayout)
}

export default BodyLayout
